import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { getResources, supportedLngs, fallbackLng } from "@jackedlogs/i18n";

// Browser-language detection with English fallback. Order:
//   1. Explicit choice persisted in localStorage (lets the user pin a language)
//   2. navigator.language(s) — the browser's preferred locale
//   3. <html lang> — last-resort hint from the document
// Anything outside the supportedLngs whitelist falls back to English.
void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: getResources(),
    fallbackLng,
    supportedLngs: [...supportedLngs],
    nonExplicitSupportedLngs: true, // "fr-CH" → "fr", "de-CH" → "de"
    interpolation: {
      escapeValue: false, // React already escapes
    },
    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"],
      lookupLocalStorage: "jl.lang",
    },
  });

// No export on purpose: this module is imported for its side effect only
// (`main.tsx` does `import "./i18n";`), and every consumer on web reaches the
// configured singleton through `useTranslation()` from react-i18next — which
// is where `PreferencesScreen` gets the `i18n` it calls `changeLanguage` on.
//
// The mobile sibling DOES export a default, and that is not drift: it has
// callers that need the singleton with no component tree around them —
// `src/i18n/locale.ts` (reads/writes the language), plus `timerNotification.ts`
// and `workoutForegroundService.ts`, which call `i18n.t` to build notification
// copy from background code. If web ever grows such a caller, the default
// comes back with it.
